import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CollectionWorldMap } from "@/components/WorldMap";
import { BookOpen, Globe, FileSpreadsheet, Loader2, BookMarked } from "lucide-react";
import { toast } from "sonner";

export default function CollectionMap() {
  const [data, setData] = useState(null);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    api.get("/collection/map").then(({ data }) => setData(data)).catch(() => setData(false));
  }, []);

  const downloadExcel = async () => {
    setDownloading(true);
    try {
      const res = await api.get("/collection/export", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "drops-of-honey-collection.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("Excel file downloaded");
    } catch (e) {
      toast.error("Could not download");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 lg:px-8 py-10">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <div>
          <p className="font-tech text-xs uppercase tracking-widest brand-text">Around the world</p>
          <h1 className="font-display text-4xl font-bold">My Collection Map</h1>
        </div>
        <button data-testid="download-excel-btn" onClick={downloadExcel} disabled={downloading} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full font-semibold text-white disabled:opacity-60" style={{ background: "var(--brand)" }}>
          {downloading ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileSpreadsheet className="w-4 h-4" />}
          {downloading ? "Preparing…" : "Download Excel"}
        </button>
      </div>

      <div className="flex gap-2 mb-8">
        <Link to="/collection" data-testid="tab-collection" className="px-4 py-2 rounded-full text-sm font-semibold surface border inline-flex items-center gap-2"><BookOpen className="w-4 h-4" /> My Collection</Link>
        <span data-testid="tab-map-active" className="px-4 py-2 rounded-full text-sm font-semibold text-white inline-flex items-center gap-2" style={{ background: "var(--brand)" }}><Globe className="w-4 h-4" /> World Map</span>
        <Link to="/collection/passport" data-testid="tab-passport" className="px-4 py-2 rounded-full text-sm font-semibold surface border inline-flex items-center gap-2"><BookMarked className="w-4 h-4" /> Passport</Link>
      </div>

      {data === false ? (
        <p className="text-muted-page">Could not load your map.</p>
      ) : !data ? (
        <div className="text-center py-20 text-muted-page animate-pulse font-tech">Loading map…</div>
      ) : (
        <CollectionWorldMap data={data} />
      )}
    </div>
  );
}
